import styled from "styled-components";
import { colors } from "../../common/ui/globalColors";
import { fonts } from "../../common/ui/globalFonts";

export const BankInfoStyled = styled.div`
   width: 100%;
   padding: 0 20px;
   color: ${colors.textColors.white};
   font-family: ${fonts.secondaryFontFamily};
   margin-top: 30px;

   .text-block {
        margin-bottom: 40px;
        text-align: start;

        .block-header {
            margin-bottom: 16px;
            font-size: 20px;
        }
    }

   .btn-wrapper {
        width: 100%;
        display: flex;
        justify-content: center;

        .app-btn {
            font-weight: 400;
            height: 60px;
            font-size: 20px;
            position: relative;
            padding-left: ${({ ltr }) => ltr ? '' : '50px'};
            padding-right: ${({ ltr }) => ltr ? '50px' : ''};
            background: rgba(245, 245, 255, 0.1);

            .arrow {
                transform: ${({ ltr }) => ltr ? 'rotate(180deg)' : 'rotate(0deg)'};
                position: absolute;
                right: ${({ ltr }) => ltr ? '10px' : ''};
                left: ${({ ltr }) => ltr ? '' : '10px'};
            }
        }
    }

    @media screen and (max-width: 768px) {
        .app-btn {
            width: 100%;
            margin: 0 10px;
        }
    }
`